const lang = {
    'hop-on': 'Hop on!',
    'decription-1': 'Freedom to get around town is just one click away. Need a ride to get to work? Planning to meet up with some friends in the evening? <span class="text-wrap-ex-sm">Or, want to get out of town for the weekend? <span class="text-wrap-sm">GoShare has you covered.</span></span>',
    'decription-2': 'With GoShare and GoShare DOTS, you can find, reserve, and ride <span class="text-wrap-ex-sm">a Gogoro Smartscooter or a Powered by Gogoro Network (PBGN)</span> scooter <span class="text-wrap-sm">any time you need it.</span>',
};

export default lang;
